var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyKrw = function SvgIconCurrencyKrw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.176 6.373a1 1 0 0 0-1.852.753l1.878 4.624H1.5a1 1 0 1 0 0 2h2.514L6.2 19.126a1 1 0 0 0 1.852 0l2.185-5.376h3.528l2.185 5.376a1 1 0 0 0 1.853 0l2.184-5.376H22.5a1 1 0 1 0 0-2h-1.702l1.879-4.624a1 1 0 0 0-1.854-.753L18.64 11.75h-3.528l-2.184-5.377a1 1 0 0 0-1.854 0L8.89 11.75H5.361zm2.997 7.377.952 2.343.952-2.343zm4.875-2h1.904L12 9.407zm4.875 2 .952 2.343.952-2.343z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyKrw;